// Resolved from process.env, which works in both Next.js (server runtime) and
// the Sanity CLI schema extractor (CJS). Avoids `import.meta`, which esbuild
// cannot transform under CJS output — that broke `sanity schema extract`.
export const token =
  process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN ||
  process.env.SANITY_API_READ_TOKEN ||
  process.env.SANITY_API_TOKEN

if (!token) {
  throw new Error("Missing SANITY_API_READ_TOKEN")
}
